import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";

interface DanielsEntry {
    ID: string,
    gDisp_opus: string,
    gDisp_1: string
}
class DanielsMusicFinder extends compose(FinderBaseV2) {

    private selectedWorksTable: MdsLax<InstanceType<typeof StaticTable>>;
    private selectedWorksEntries: Array<DanielsEntry> = [];
    private selectedWorksExpander: MdsLax<InstanceType<typeof ExpandableSection>>;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>>;
    private _timeout: any = null;

    private _tableFormatter(cell: StaticTable.StaticTableCell<DanielsEntry>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let node = cell.tableCellNode;
        let value = cell.value;

        switch (name) {

        }

        return false;
    }


    private _onRowClick(row: StaticTable.StaticTableRow<DanielsEntry>, rowGroup: StaticTable.StaticTableRowGroup<DanielsEntry>, evt) {

        let entity = rowGroup.entity;

        this.disableNode(row.node);

        if (this.selectedWorksEntries.findIndex(x => x.ID === entity.ID) != -1) return;

        this.selectedWorksEntries.push(entity);
        
        this.updateTable();
    }

    private removeEntry(rowGroup: StaticTable.StaticTableRowGroup<DanielsEntry>) {

        let disabledRowGroup = this.table.getRowGroupByKeyValue(rowGroup.entity.ID);
        disabledRowGroup?.rows.forEach((x) => this.disableNode(x.node, false));
        this.updateTable();
    }

    showSearchWidget() {

        this.dlg = new GenericDialog();

        this.dlg.show(this,
            this.translate("DanielsMusicFinder_Header"),
            null,
            null,
            "submitcancel",
            lang.hitch(this, this.submitWorksEntries),
            {
                closeOnEnter: false,
                closeOnEscape: false,
                keepOpen: true
            }
        )
        this.dlg.disableButton("submit");
        this.hourGlassEnd(this);
    }

    private submitWorksEntries(response) {

        if (response === 1) { //submit

            this.sendWorksToProcess();
            return;
        }

        this.dlg.close();
    }

    private sendWorksToProcess() {

        this.RequestManager.callfunction(
            "Webtool_API_DanielsMusicSearch_ProcessSelectedWorksEntries",
            this.selectedWorksEntries,
            lang.hitch(this, this.sendWorksToProcessResponse),
            (err) => { this.showToast(err.Message) }
        )
    }
    private sendWorksToProcessResponse(response: { opusList: Array<{ ID: string, gDisp_1: string }>, newOpusList: Array<string> } ) {

        let responseDlg = new GenericDialog();

        let content = this.UiModder.domConstruct.create("div");

        response.opusList.forEach((o) => {

            if (response.newOpusList.indexOf(o.ID) != -1) {

                this.UiModder.domConstruct.create("p", { innerHTML: ` - ${this.translate("General_New").toUpperCase()}!: ${o.gDisp_1}`, class: "bold" }, content);
            } else {

                this.UiModder.domConstruct.create("p", { innerHTML: ` - ${o.gDisp_1}` }, content);
            }            
        })

        this.UiModder.domConstruct.create("hr", null, content);
        this.UiModder.domConstruct.create("h6", { innerHTML: this.translate("DanielsMusicFinder_Header_OpenEditors") }, content);

        responseDlg.show(content,
            this.translate("DanielsMusicFinder_Header_DanielsWorksInDatabase"),
            null,
            null,
            "yesno",
            lang.hitch(this, this.openOpusEditors, response.opusList),
            {
                closeOnEnter: false,
                closeOnEscape: false,
                size: "smaller"
            }
        )

        this.dlg.close();
    }

    private openOpusEditors(opusList: Array<{ ID: string, gDisp_opus: string }>, res) {

        if (res === 2) { //yes
            opusList.forEach((o) => {

                this.emit("RequestNewEditorInstance", o);
            });
        }
    }

    private updateTable() {

        this.selectedWorksTable.setData(this.selectedWorksEntries);

        if (this.selectedWorksEntries.length > 0) {

            this.selectedWorksExpander.setMarking(ExpandableSectionMarkings.hasContent);
            this.dlg.enableButton("submit");
            return;
        }
        this.selectedWorksExpander.setMarking(ExpandableSectionMarkings.default);
        this.dlg.disableButton("submit");
    }

    private setupSelectedEntriesSection() {

        this.RequestManager.callfunction(
            "Webtool_API_DanielsMusicSearch__GetSelectedEntriesTableLayout",
            null,
            lang.hitch(this, this.tableLayoutResponse),
            (err) => { this.showToast(err.Message) }
        )
    }

    private reactToFinderTableChange() {

        if (this._timeout != null) clearTimeout(this._timeout);
        this._timeout = setTimeout(() => {
            this.hideNode(this.selectedWorksExpander, false)

            this.selectedWorksEntries.forEach((x) => {
                let rowGroup = this.table?.getRowGroupByKeyValue(x.ID);
                rowGroup?.rows.forEach((y) => { this.disableNode(y.node) });
            });
        }, 50);
    }

    private tableLayoutResponse(response: { layouts: Array<any> }) {
                
        if (this.selectedWorksTable != null) this.selectedWorksTable.destroy();

        this.selectedWorksTable = new StaticTable();
        this.selectedWorksExpander = new ExpandableSection();

        this.hideNode(this.selectedWorksExpander);
        this.on("tableAssigned", lang.hitch(this.reactToFinderTableChange));
        
        this.selectedWorksExpander.placeAt(this.tableContainer, "after");

        this.selectedWorksExpander.setup(this.selectedWorksTable.domNode,
            this.translate("DanielsMusicFinder_Label_SelectedEntries")
        );

        this.hourGlassStart(this.selectedWorksExpander); 

        this.selectedWorksTable.setLayout(response.layouts[0]);
        this.selectedWorksTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeEntry));

        this.updateTable();
        this.hourGlassEnd(this.selectedWorksExpander); 
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.hourGlassStart(this);
        this.setupFinderWithCallfunctions(
            "Webtool_API_DanielsMusicSearch_GetFinderConfig",
            "Webtool_API_DanielsMusicSearch_GetFinderResults",
            lang.hitch(this, this._onRowClick),
            lang.hitch(this, this._tableFormatter));

        this.setupSelectedEntriesSection();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(DanielsMusicFinder);